export default __webpack_public_path__ + "static/media/location-logo.e392fd33.svg";